module.exports = __webpack_public_path__ + "static/media/motorbike.86883e16.svg";